<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.5559 10.6911 11.1584 11.0004 10.8816C11.2667 10.6432 11.6149 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12Z" fill="black" stroke="black" stroke-width="3"/>
    </svg>
</template>

<script>
    export default {
        name: 'Dot'
    }
</script>